import React from 'react'

export default function WrapperForms({ children }) {
  return (
    <div className='d-flex flex-wrap start'>{children}</div>
  )
}
